import { useEffect, useState } from 'react'
import { Bars3Icon } from '@heroicons/react/24/outline'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartPlus, faSearch } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-regular-svg-icons'
import { Dropdown } from 'primereact/dropdown'
import { useLocation } from 'react-router'
import { MobileMnue, RoutesGroup } from './components'
import { Link } from 'react-router-dom'


export default function Example() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [selectedLang, setSelectedLang] = useState(null);
    const [bgGradient, setBgGradient] = useState(false);
    const location = useLocation().pathname;

    const lang = [
        { name: 'العربيه', code: 'NY' },
        { name: 'English', code: 'RM' }
    ];


    useEffect(() => {

        location === '/' ? setBgGradient(true) : setBgGradient(false);

    }, location);
    return (
        <header className={`relative z-[10] ${bgGradient ? "" : "pb-6"}`} style={{ background: bgGradient ? 'linear-gradient(90deg, rgba(85,21,86,1) 0%, rgba(177,120,166,0.77) 40%, rgba(108,22,106,1) 100%)' : 'linear-gradient(90deg, rgba(146,31,151,1) 0%, rgba(116,24,116,1) 31%, rgba(128,27,130,1) 100%)' }}>
            <nav className="container flex items-center justify-between flex-wrap p-6 lg:px-8" aria-label="Global">
                <Link to={'/'}>
                    <img src={require('../../../assets/images/logo.png')} />
                </Link>
                <div className="flex lg:hidden">
                    <button
                        type="button"
                        className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 white"
                        onClick={() => setMobileMenuOpen(true)}
                    >
                        <span className="sr-only">Open main menu</span>
                        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                    </button>
                </div>
                <RoutesGroup />
                <div className="hidden lg:flex  lg:justify-end text-white">

                    <div className='flex items-center me-5'>

                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <g clip-path="url(#clip0_86_3358)">
                                <path d="M0.66674 7.33341C0.489929 7.33341 0.320359 7.26317 0.195335 7.13815C0.0703107 7.01312 7.2824e-05 6.84355 7.2824e-05 6.66674C0.00201389 4.89923 0.705016 3.20467 1.95484 1.95485C3.20466 0.705029 4.89923 0.00202656 6.66674 8.58307e-05C6.84355 8.58307e-05 7.01312 0.070323 7.13814 0.195347C7.26317 0.320371 7.33341 0.489941 7.33341 0.666752C7.33341 0.843562 7.26317 1.01313 7.13814 1.13816C7.01312 1.26318 6.84355 1.33342 6.66674 1.33342C5.25274 1.33501 3.89711 1.89742 2.89726 2.89727C1.89741 3.89712 1.33499 5.25274 1.33341 6.66674C1.33341 6.84355 1.26317 7.01312 1.13814 7.13815C1.01312 7.26317 0.843551 7.33341 0.66674 7.33341ZM4.00007 6.66674C4.00007 5.9595 4.28102 5.28123 4.78112 4.78113C5.28122 4.28103 5.9595 4.00008 6.66674 4.00008C6.84355 4.00008 7.01312 3.92984 7.13814 3.80482C7.26317 3.6798 7.33341 3.51023 7.33341 3.33342C7.33341 3.1566 7.26317 2.98703 7.13814 2.86201C7.01312 2.73699 6.84355 2.66675 6.66674 2.66675C5.6062 2.66781 4.5894 3.08957 3.83948 3.83949C3.08957 4.58941 2.6678 5.6062 2.66674 6.66674C2.66674 6.84355 2.73698 7.01312 2.862 7.13815C2.98703 7.26317 3.1566 7.33341 3.33341 7.33341C3.51022 7.33341 3.67979 7.26317 3.80481 7.13815C3.92984 7.01312 4.00007 6.84355 4.00007 6.66674ZM11.1594 0.604752C11.5468 0.218411 12.0716 0.00145721 12.6187 0.00145721C13.1659 0.00145721 13.6907 0.218411 14.0781 0.604752L14.7774 1.21142C20.0047 6.67141 6.72141 19.9581 1.24407 14.8114L0.577406 14.0447C0.201858 13.6569 -0.00589446 13.1368 -0.000903948 12.5969C0.00408656 12.0571 0.221418 11.5409 0.604073 11.1601C0.62474 11.1394 2.22941 9.90407 2.22941 9.90407C2.61449 9.53752 3.12603 9.33347 3.65768 9.33434C4.18932 9.33521 4.70019 9.54093 5.08407 9.90874L6.05474 10.6807C7.09281 10.2535 8.03624 9.62536 8.8308 8.8324C9.62537 8.03944 10.2554 7.09729 10.6847 6.06008L9.90807 5.08341C9.54055 4.69948 9.33507 4.18871 9.33433 3.65722C9.33358 3.12573 9.53763 2.61438 9.90407 2.22942C9.90407 2.22942 11.1387 0.625418 11.1594 0.604752ZM12.1287 1.52208C12.1287 1.52208 10.9014 3.11742 10.8807 3.13808C10.7446 3.27542 10.6682 3.461 10.6682 3.65442C10.6682 3.84783 10.7446 4.0334 10.8807 4.17075C10.8994 4.18875 11.9707 5.53341 11.9707 5.53341C12.0429 5.62403 12.0901 5.73187 12.1079 5.84631C12.1257 5.96076 12.1133 6.07786 12.0721 6.18608C11.5718 7.52977 10.7886 8.75025 9.77546 9.76485C8.76235 10.7794 7.54303 11.5645 6.20007 12.0667C6.09038 12.1113 5.9708 12.1258 5.85363 12.1088C5.73647 12.0918 5.62594 12.0439 5.53341 11.9701C5.53341 11.9701 4.18807 10.8987 4.17074 10.8807C4.0334 10.7446 3.84782 10.6682 3.65441 10.6682C3.461 10.6682 3.27542 10.7446 3.13807 10.8807C3.11807 10.9014 1.52141 12.1287 1.52141 12.1287C1.39641 12.2681 1.32947 12.4501 1.3343 12.6372C1.33914 12.8244 1.41538 13.0026 1.54741 13.1354L2.21407 13.9021C6.73674 17.6634 17.6121 6.14941 13.8667 2.18608L13.1667 1.57875C13.0349 1.43643 12.8529 1.35095 12.6592 1.34037C12.4655 1.3298 12.2753 1.39496 12.1287 1.52208Z" fill="white" />
                            </g>
                            <defs>
                                <clipPath id="clip0_86_3358">
                                    <rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)" />
                                </clipPath>
                            </defs>
                        </svg>

                        <p className='ms-2'>966556754472+</p>


                    </div>

                    <div className='flex items-center'>

                        <button className='me-5 flex items-center border border-white p-2 px-3 rounded-[5px]'>

                            <FontAwesomeIcon icon={faUser} className='me-2' />

                            <span>تسجيل الدخول</span>

                        </button>

                        <button className='p-2 px-3 rounded-[5px] border border-white flex items-center justify-center'>

                            <FontAwesomeIcon icon={faCartPlus} className='text-[20px]' />

                        </button>

                    </div>

                </div>
                <div className='w-full pt-3 flex items-center justify-between'>

                    <div className='relative flex-1 me-5'>

                        <input type='text' className={`w-full bg-transparent p-2 px-16 ${bgGradient ? "text-white" : "bg-white rounded-full"} placeholder:text-[#bb8bbb] border-b border-b-white`} placeholder='ابحث' />

                        <FontAwesomeIcon icon={faSearch} className={`absolute right-4 top-[50%] translate-y-[-50%] ${bgGradient ? "text-white" : ""} text-[18px]`} />

                    </div>

                    <Dropdown value={selectedLang} onChange={(e) => setSelectedLang(e.value)} options={lang} optionLabel="name"
                        placeholder="العربية - رس" className="w-fit !p-0 !text-white !bg-transparent" style={{ direction: 'ltr' }} />

                </div>
            </nav>

            <MobileMnue mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />

        </header>
    )
}
